module.exports = __webpack_public_path__ + "img/ss my work.6e0f5ad6.jpg";